import 'core-js/modules/es.array.for-each';

let activeSnackbars = [];
const timeout = 5000;

const showSnackbar = (snackbar) => {
  if (navigator.userAgent.includes('iPhone')) {
    snackbar.classList.add('ios__iphone');
  }
  snackbar.classList.add('show');

  setTimeout(function () {
    hideSnackbar(snackbar);
  }, timeout);

  let closeButton = snackbar.querySelector('.js-close-snackbar');
  closeButton.addEventListener('click', function (e) {
    e.preventDefault();
    hideSnackbar(snackbar);
  });
};

const hideSnackbar = (snackbar) => {
  snackbar.classList.remove('show');
  removeItem(snackbar);

  if (activeSnackbars.length > 0) {
    showSnackbar(activeSnackbars[0]);
  }
};

const removeItem = (snackbar) => {
  activeSnackbars = activeSnackbars.filter((item) => item !== snackbar);
};

export const initSnackbar = () => {
  const listOfSnackbars = document.getElementsByClassName('js-snackbar');
  if (listOfSnackbars.length > 0) {
    Array.prototype.slice.call(listOfSnackbars).forEach((snackbar, index) => {
      if (index === 0) {
        showSnackbar(snackbar);
      }

      activeSnackbars.push(snackbar);
    });
  }
};
